"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@/utils");
var _juyc = require("@/api/jhyc/juyc");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 引入第一步定义的API
var _default = exports.default = {
  name: 'SecurityOrderImport',
  data: function data() {
    return {
      dialogTitle: '导入安全检测订单',
      dialogVisible: false,
      listLoading: false,
      serviceItemId: 'aqjc001',
      // 默认值，可根据需求置空
      tableData: []
    };
  },
  methods: {
    open: function open() {
      this.dialogVisible = true;
      this.tableData = [];
      this.serviceItemId = 'aqjc001'; // 每次打开重置或保持默认
    },
    /** 下载模板 */downloadFile: function downloadFile() {
      // 确保后端或文件服务器有这个文件
      (0, _utils.downloadTemplate)('安全检测订单模板.xlsx', '/file/安全检测订单模板.xlsx');
    },
    /** 导入逻辑 */uploadFile: function uploadFile(option) {
      var _this = this;
      if (!this.serviceItemId) {
        this.$message.warning('请输入服务项目ID');
        return;
      }
      if (option.file) {
        var formData = new FormData();
        formData.append('file', option.file);
        // 后端接口要求必填 @RequestParam("serviceItemId")
        formData.append('serviceItemId', this.serviceItemId);
        this.listLoading = true;
        (0, _juyc.importSecurityOrderApi)(formData).then(function (res) {
          var newData = [];

          // 处理成功列表
          if (res.successList && res.successList.length > 0) {
            for (var i = 0; i < res.successList.length; i++) {
              // 成功的项没有reason字段，这里为了表格显示统一，可以不加或加个标识
              newData.push(_objectSpread(_objectSpread({}, res.successList[i]), {}, {
                reason: '' // 标记为无错误
              }));
            }
          }

          // 处理失败列表 (FailureItem<T>)
          if (res.failureList && res.failureList.length > 0) {
            for (var _i = 0; _i < res.failureList.length; _i++) {
              var failureItem = res.failureList[_i];
              newData.push(_objectSpread(_objectSpread({}, failureItem.item), {}, {
                // 展开原始数据对象
                reason: failureItem.reason // 添加失败原因
              }));
            }
          }
          _this.tableData = newData;
          var successCount = res.successCount || 0;
          var total = res.total || 0;
          var msg = total === successCount ? "\u5168\u90E8\u5BFC\u5165\u6210\u529F\uFF0C\u5171".concat(successCount, "\u6761") : "\u5BFC\u5165\u5B8C\u6210\uFF1A\u6210\u529F ".concat(successCount, " \u6761\uFF0C\u5931\u8D25 ").concat(res.failCount, " \u6761");
          if (res.failCount > 0) {
            _this.$message.warning(msg);
          } else {
            _this.$message.success(msg);
          }

          /** 清除文件，允许重复上传 */
          _this.$refs.upload.clearFiles();

          // 如果有成功的，通知父组件刷新列表
          if (successCount > 0) {
            _this.$emit('success');
          }
        }).catch(function (err) {
          _this.$message.error(err.message || '导入失败');
        }).finally(function () {
          _this.listLoading = false;
        });
      }
    }
  }
};